import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import store from '../store'

Vue.use(VueRouter)

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                  菜单栏是否显示，默认false
 * alwaysShow: true              是否总是显示一级节点，默认false，子节点大于2时才显示，只有一个子节点时，子节点占位
 * redirect: noRedirect          配置为noRedirect ，面包屑中不能跳转
 * name:'router-name'            the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            配置为false，不会出现在面包屑中，默认true
    activeMenu: '/example/list'  默认选中的菜单
  }
 */

/**
 * 导航要出现在标签栏，需要配置：
 * 1.路由配置name属性，且对应组件增加name属性，二者必须一致，通常首字母大写
 * 2.路由meta中配置title属性，affix表示是否固定在标签栏
 */

export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    hidden: true,
    meta: {
      title: '登录'
    }
  }
];

// 需要通过权限控制菜单时，过滤asyncRoutes，动态加载，当前未使用权限
export const asyncRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: "home",
    children: [
      {
        name: 'Home',
        path: 'home',
        component: () => import('@/views/home/home'),
        meta: {
          title: '首页',
          activeMenu: '/home',
          icon: 'el-icon-setting'
        }
      },
      {
        name: 'chartPage',
        path: '/chart-Page',
        component: () => import('@/views/chart-page/index'),
        meta: {
          title: '工作台',
        }
      }
    ]
  },
  {
    path: '/public',
    component: Layout,
    redirect: '/public/export-list',
    children: [
      {
        name: 'ImportListPage',
        path: 'import-list',
        component: () => import('@/views/admin-plugin/import-list/import-list-page.vue'),
        meta: {
          title: '导入列表'
        }
      },
      {
        name: 'ExportListPage',
        path: 'export-list',
        component: () => import('@/views/admin-plugin/export-list/export-list-page.vue'),
        meta: {
          title: '导出列表'
        }
      },
      {
        name: 'RoleUserConfig',
        path: 'role-user',
        component: () => import('@/views/admin-plugin/role-user-config/role-user-config.vue'),
        meta: {
          title: '角色人员配置'
        }
      },
    ]
  },
  {
    path: '/activity',
    component: Layout,
    redirect: '/activity/list',
    meta: {
      title: '活动管理',
      icon: 'el-icon-setting'
    },
    children: [
      {
        name: 'TemplateList',
        path: 'template',
        component: () => import('@/views/activity-templates/activity-template-list'),
        meta: {
          title: '活动模板'
        }
      },
      {
        name: 'ActivityList',
        path: 'list',
        component: () => import('@/views/activity-management/activity-list'),
        meta: {
          title: '活动列表'
        }
      },
      {
        name: 'ActiviDetail',
        path: 'detail',
        component: () => import('@/views/activity-management/activity-detail'),
        meta: {
          title: '活动详情'
        }
      },
      {
        name: 'PartakeList',
        path: 'partake-list',
        component: () => import('@/views/activity-management/partake-list'),
        meta: {
          title: '参与列表'
        }
      }
    ]
  },
  {
    path: '/content',
    component: Layout,
    redirect: '/content/carousel',
    meta: {
      title: '内容管理',
      icon: 'el-icon-setting'
    },
    children: [
      {
        name: 'ImageCarouselList',
        path: 'carousel',
        component: () => import('@/views/image-carousel/image-carousel-list'),
        meta: {
          title: '轮播列表'
        }
      },
      {
        name: 'Asewers',
        path: 'asewers',
        component: () => import('@/views/image-carousel/asewers/asewers-list'),
        meta: {
          title: '试题列表'
        }
      },
      {
        name: 'NewaddOrEdit',
        path: 'newaddOrEdit',
        component: () => import('@/views/image-carousel/asewers/newaddOrEdit'),
        meta: {
          title: '试卷详情'
        }
      },
      {
        name: 'messageList',
        path: 'message-list',
        component: () => import('@/views/image-carousel/message/message-list'),
        meta: {
          title: '短信发送'
        }
      },
      {
        name: 'addMessage',
        path: 'add-message',
        component: () => import('@/views/image-carousel/message/add-message'),
        meta: {
          title: '新建发送'
        }
      },
      {
        name: 'helpList',
        path: 'helpList',
        component: () => import('@/views/image-carousel/help/list'),
        meta: {
          title: '帮助与培训材料'
        }
      },
      
    ]
  },
  {
    path: '/dataReport',
    component: Layout,
    redirect: '/dataReport/list',
    meta: {
      title: '数据报表',
      icon: 'el-icon-setting'
    },
    children: [
      {
        name: 'dataList',
        path: 'list',
        component: () => import('@/views/data-report/data-list'),
        meta: {
          title: '区域列表'
        }
      },
      {
        name: 'manageList',
        path: 'manage',
        component: () => import('@/views/data-report/manage-list'),
        meta: {
          title: '区经理列表'
        }
      },
      {
        name: 'dealerList',
        path: 'dealer',
        component: () => import('@/views/data-report/dealer-list'),
        meta: {
          title: '经销商列表'
        }
      },
      {
        name: 'storeList',
        path: 'store',
        component: () => import('@/views/data-report/store-list'),
        meta: {
          title: '门店列表'
        }
      },
      {
        name: 'employeeList',
        path: 'employee',
        component: () => import('@/views/data-report/employee-list'),
        meta: {
          title: '职员列表'
        }
      },
      {
        name: 'orderData',
        path: 'order-data',
        component: () => import('@/views/data-report/order-data'),
        meta: {
          title: '订单数据'
        }
      },
      {
        name: 'newOrderData',
        path: 'new-order-data',
        component: () => import('@/views/data-report/new-order-data'),
        meta: {
          title: '订单数据(新)'
        }
      },
      {
        name: 'signupData',
        path: 'signup-data',
        component: () => import('@/views/data-report/signup-data'),
        meta: {
          title: '报名数据'
        }
      },
      {
        name: 'lotteryData',
        path: 'lottery-data',
        component: () => import('@/views/data-report/lottery-data'),
        meta: {
          title: '抽奖数据'
        }
      },
      {
        name: 'spikeData',
        path: 'spike-data',
        component: () => import('@/views/data-report/spike-data'),
        meta: {
          title: '秒杀数据'
        }
      },
      {
        name: 'answerData',
        path: 'answer-data',
        component: () => import('@/views/data-report/answer-data'),
        meta: {
          title: '问答数据'
        }
      },
      {
        name: 'groupData',
        path: 'group-data',
        component: () => import('@/views/data-report/group-data'),
        meta: {
          title: '拼团数据'
        }
      },
      {
        name: 'drawlotData',
        path: 'drawlot-data',
        component: () => import('@/views/data-report/drawlot-data'),
        meta: {
          title: '求签数据'
        }
      },
      {
        name: 'dataLachine',
        path: 'lachine',
        component: () => import('@/views/data-report/data-lachine'),
        meta: {
          title: '拉新数据'
        }
      },
      {
        name: 'lashinDetail',
        path: 'lashin-detail',
        component: () => import('@/views/data-report/lashin-detail'),
        meta: {
          title: '拉新明细'
        }
      },
      {
        name: 'withdrawalList',
        path: 'withdrawal',
        component: () => import('@/views/data-report/withdrawal-list'),
        meta: {
          title: '提现列表'
        }
      },
      {
        name: 'walletList',
        path: 'wallet',
        component: () => import('@/views/data-report/wallet-list'),
        meta: {
          title: '经销商钱包列表'
        }
      },
      {
        name: 'transferRecord',
        path: 'transfer-record',
        component: () => import('@/views/data-report/transfer-record'),
        meta: {
          title: '转账记录'
        }
      },
      {
        name: 'adjustRecord',
        path: 'adjust-record',
        component: () => import('@/views/data-report/adjust-record'),
        meta: {
          title: '调账记录'
        }
      },
      {
        name: 'walletRecord',
        path: 'wallet-record',
        component: () => import('@/views/data-report/wallet-record'),
        meta: {
          title: '钱包记录'
        }
      },

      {
        name: 'smsList',
        path: 'smsList',
        component: () => import('@/views/data-report/sms-list'),
        meta: {
          title: '短信数据'
        }
      },
      {
        name: 'smsDetail',
        path: 'smsDetail',
        component: () => import('@/views/data-report/sms-detail'),
        meta: {
          title: '短信详情'
        }
      },
      {
        name: 'phoneInterfaceData',
        path: 'phone-interface-data',
        component: () => import('@/views/data-report/phone-interface-data'),
        meta: {
          title: '手机号接口数据'
        }
      },
      {
        name: 'writeoffSignup',
        path: 'writeoff-signup',
        component: () => import('@/views/data-report/writeoff-signup'),
        meta: {
          title: '核销报名'
        }
      },
      {
        name: 'writeoffRecord',
        path: 'writeoff-record',
        component: () => import('@/views/data-report/writeoff-record'),
        meta: {
          title: '核销记录'
        }
      },
      {
        name: 'writeoffDetail',
        path: 'writeoff-detail',
        component: () => import('@/views/data-report/writeoff-detail'),
        meta: {
          title: '核销明细'
        }
      },
      {
        name: 'rechargeRecord',
        path: 'recharge-record',
        component: () => import('@/views/data-report/recharge-record'),
        meta: {
          title: '充值记录'
        }
      },
      {
        name: 'account',
        path: 'account',
        component: () => import('@/views/data-report/account/home'),
        meta: {
          title: '商户号流水对账'
        }
      },
      {
        name: 'record',
        path: 'record',
        component: () => import('@/views/data-report/account/record'),
        meta: {
          title: '对账记录'
        }
      },
      {
        name: 'checkData',
        path: 'check-data',
        component: () => import('@/views/data-report/check-data/check-data'),
        meta: {
          title: '财务数据核对'
        }
      },
      {
        name: 'earnestMoneyList',
        path: 'earnest-money-list',
        component: () => import('@/views/data-report/earnest-money-audit/earnest-money-list'),
        meta: {
          title: '保证金审核'
        }
      },
      {
        name: 'activityDataDetails',
        path: 'activity-data-details',
        component: () => import('@/views/data-report/check-data/activity-data-details'),
        meta: {
          title: '活动数据明细'
        }
      },
      {
        name: 'dealerDataDetails',
        path: 'dealer-data-details',
        component: () => import('@/views/data-report/check-data/dealer-data-details'),
        meta: {
          title: '经销商钱包核对记录'
        }
      },
      {
        name: 'errResult',
        path: 'errResult',
        component: () => import('@/views/data-report/check-data/err-result'),
        meta: {
          title: '银联核对异常订单'
        }
      },
      {
        name: 'capitalRecord',
        path: 'capital-record',
        component: () => import('@/views/data-report/check-data/capital-record'),
        meta: {
          title: '资金核对记录'
        }
      },
      {
        name: 'activityRecord',
        path: 'activity-record',
        component: () => import('@/views/data-report/check-data/activity-record'),
        meta: {
          title: '活动核对记录'
        }
      },
      {
        name: 'dealerRecord',
        path: 'dealer-record',
        component: () => import('@/views/data-report/check-data/dealer-record'),
        meta: {
          title: '经销商核对记录'
        }
      },
      {
        name: 'financialDataDetails',
        path: 'financial-data-details',
        component: () => import('@/views/data-report/check-data/financial-data-details'),
        meta: {
          title: '银联订单详情'
        }
      },
      {
        name: 'DataAnalysisViews',
        path: 'dataAnalysisViews',
        component: () => import('@/views/dataAnalysis/dataAnalysisViews'),
        meta: {
          title: '数据分析'
        }
      },
      {
        name: 'WeChatData',
        path: 'weChatData',
        component: () => import('@/views/dataAnalysis/weChatData'),
        meta: {
          title: '微信数据'
        }
      },
      {
        name: 'redChallenge',
        path: 'redChallenge',
        component: () => import('@/views/data-report/red-challenge/red-challenge'),
        meta: {
          title: '红包挑战赛数据'
        }
      },
      {
        name: 'refundOrder',
        path: 'refundOrder',
        component: () => import('@/views/data-report/refund-order/refund-order'),
        meta: {
          title: '退款订单'
        }
      },
      {
        name: 'messageInform',
        path: 'messageInform',
        component: () => import('@/views/data-report/message-inform/message-inform'),
        meta: {
          title: '消息通知'
        }
      },
      {
        name: 'couponData',
        path: 'coupon-data',
        component: () => import('@/views/data-report/coupon-data/coupon-data'),
        meta: {
          title: '优惠券数据'
        }
      },
      {
        name: 'netInList',
        path: 'net-in-list',
        component: () => import('@/views/data-report/net-in-list/net-in-list'),
        meta: {
          title: '入网列表'
        }
      },
      {
        name: 'dealerPayManage',
        path: 'dealerPayManage',
        component: () => import('@/views/data-report/dealer-pay-manage/dealer-pay-manage'),
        meta: {
          title: '经销商支付管理'
        }
      },
    ]
  },
  {
    path: '/configure',
    component: Layout,
    redirect: '/configure/weChatVideoNumber',
    meta: {
      title: '配置管理',
      icon: 'el-icon-setting'
    },
    children: [
      {
        name: 'weChat',
        path: 'weChatVideoNumber',
        component: () => import('@/views/configure/weChat-video-number'),
        meta: {
          title: '微信视频号配置'
        }
      },
      {
        name: 'teacher',
        path: 'activityTeacher',
        component: () => import('@/views/configure/activity-teacher'),
        meta: {
          title: '活动老师配置列表'
        }
      },
      {
        name: 'dataField',
        path: 'dataFieldList',
        component: () => import('@/views/configure/dataField/list'),
        meta: {
          title: '数据字典列表'
        }
      },
      {
        name: 'dictionaries',
        path: 'dictionaries',
        component: () => import('@/views/configure/dataField/detail'),
        meta: {
          title: '字典详情'
        }
      },
      {
        name: 'smsTemplateList',
        path: 'smsTemplateList',
        component: () => import('@/views/configure/smsTemplate/template-list'),
        meta: {
          title: '短信模版配置'
        }
      },
      {
        name: 'weChatKeyList',
        path: 'weChatKeyList',
        component: () => import('@/views/configure/weChatKey/weChatKey-list'),
        meta: {
          title: '微信密钥获取'
        }
      },
      {
        name: 'dataDecode',
        path: 'data-decode',
        component: () => import('@/views/configure/data-decode'),
        meta: {
          title: '数据解密'
        }
      },
      {
        name: 'mchNoConfig',
        path: 'mchNo-Config',
        component: () => import('@/views/configure/mchNoConfig/mchNo-Config.vue'),
        meta: {
          title: '银联下线商户号配置'
        }
      },
      {
        name: 'dataPermissionConfig',
        path: 'data-permission-config',
        component: () => import('@/views/configure/dataPermissionConfig/data-permission-config.vue'),
        meta: {
          title: '数据权限配置'
        }
      },
      {
        name: 'saleTargetConfig',
        path: 'sale-target-config',
        component: () => import('@/views/configure/saleTargetConfig/sale-target-config.vue'),
        meta: {
          title: '销售目标配置'
        }
      }
    ]
  },
  {
    path: '/file',
    component: Layout,
    redirect: '/file/import',
    name: 'file',
    children: [
      {
        name: 'ImportFile',
        path: 'import',
        component: () => import('@/views/import-export/import-list'),
        meta: {
          title: '导入列表'
        }
      },
      {
        name: 'ExportFile',
        path: 'export',
        component: () => import('@/views/import-export/export-list'),
        meta: {
          title: '导出列表'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/home'
  }
];
const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  // routes: constantRoutes
  routes: [...constantRoutes, ...asyncRoutes]
})

const router = createRouter();
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}


export default router

